import { render, staticRenderFns } from "./cpt-header.vue?vue&type=template&id=67a56342&scoped=true"
import script from "./cpt-header.vue?vue&type=script&lang=js"
export * from "./cpt-header.vue?vue&type=script&lang=js"
import style0 from "./cpt-header.vue?vue&type=style&index=0&id=67a56342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a56342",
  null
  
)

export default component.exports